export default "__VITE_ASSET__D6h7D0QB__"